/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAgentsRouteImport } from './routes/_app/agents'
import { Route as AppConnectionsRouteImport } from './routes/_app/connections'
import { Route as AppRoutingRouteImport } from './routes/_app/routing'
import { Route as AppTRefRouteImport } from './routes/_app/t.$ref'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsRoute = AppAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectionsRoute = AppConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => AppRoute,
} as any)
const AppRoutingRoute = AppRoutingRouteImport.update({
  id: '/routing',
  path: '/routing',
  getParentRoute: () => AppRoute,
} as any)
const AppTRefRoute = AppTRefRouteImport.update({
  id: '/t/$ref',
  path: '/t/$ref',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AppAdminRoute
  '/agents': typeof AppAgentsRoute
  '/connections': typeof AppConnectionsRoute
  '/routing': typeof AppRoutingRoute
  '/t/$ref': typeof AppTRefRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/admin': typeof AppAdminRoute
  '/agents': typeof AppAgentsRoute
  '/connections': typeof AppConnectionsRoute
  '/routing': typeof AppRoutingRoute
  '/': typeof AppIndexRoute
  '/t/$ref': typeof AppTRefRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/agents': typeof AppAgentsRoute
  '/_app/connections': typeof AppConnectionsRoute
  '/_app/routing': typeof AppRoutingRoute
  '/_app/': typeof AppIndexRoute
  '/_app/t/$ref': typeof AppTRefRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/agents'
    | '/connections'
    | '/routing'
    | '/t/$ref'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/admin'
    | '/agents'
    | '/connections'
    | '/routing'
    | '/'
    | '/t/$ref'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/admin'
    | '/_app/agents'
    | '/_app/connections'
    | '/_app/routing'
    | '/_app/'
    | '/_app/t/$ref'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents': {
      id: '/_app/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AppAgentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connections': {
      id: '/_app/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof AppConnectionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/routing': {
      id: '/_app/routing'
      path: '/routing'
      fullPath: '/routing'
      preLoaderRoute: typeof AppRoutingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/t/$ref': {
      id: '/_app/t/$ref'
      path: '/t/$ref'
      fullPath: '/t/$ref'
      preLoaderRoute: typeof AppTRefRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppAgentsRoute: typeof AppAgentsRoute
  AppConnectionsRoute: typeof AppConnectionsRoute
  AppRoutingRoute: typeof AppRoutingRoute
  AppIndexRoute: typeof AppIndexRoute
  AppTRefRoute: typeof AppTRefRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppAgentsRoute: AppAgentsRoute,
  AppConnectionsRoute: AppConnectionsRoute,
  AppRoutingRoute: AppRoutingRoute,
  AppIndexRoute: AppIndexRoute,
  AppTRefRoute: AppTRefRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
